import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./store";
import mixpanel from "mixpanel-browser";
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

// Initialize Datadog RUM
datadogRum.init({
  applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  site: process.env.REACT_APP_DATADOG_SITE,
  service: process.env.REACT_APP_DATADOG_SERVICE,
  env: process.env.REACT_APP_DATADOG_ENV,
  version: '1.0',
  sessionSampleRate: Number(process.env.REACT_APP_DATADOG_SESSION_SAMPLE_RATE) || 10,
  sessionReplaySampleRate: Number(process.env.REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE) || 10,
  trackResources: true,
  trackUserInteractions: true,
  trackLongTasks: true,
  plugins: [reactPlugin({ router: false })],
  beforeSend: (event) => {
    // Filter out 401 errors from being reported
    if (event.type === 'error' && event.error?.message?.includes('401')) {
      return false;
    }
    if (event.type === 'resource' && event.resource?.status_code === 401) {
      return false;
    }
    return true;
  },
});

// Set user ID from localStorage if available
const userId = localStorage.getItem('userId');
if (userId) {
  datadogRum.setUser({
    id: userId,
  });
}

// Export datadogRum for use in other components
export { datadogRum };

// Near entry of your product, init Mixpanel
mixpanel.init("06a750abfe2e662b4f96d90ce3c6155d", {
  debug: true,
  track_pageview: true,
  persistence: "localStorage",
  record_sessions_percent: 1, //records 1% of all sessions
  record_heatmap_data: true,
  api_host: process.env.REACT_APP_MIXPANEL_API_HOST,
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
